var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.551,
    height: 47.551,
    viewBox: "0 0 47.551 47.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(-720.1 -587.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ambulance_FILL0_wght400_GRAD0_opsz48",
    d: "M50.325,8.55a22.935,22.935,0,0,1,16.851,6.924A22.935,22.935,0,0,1,74.1,32.325a22.935,22.935,0,0,1-6.924,16.851A22.935,22.935,0,0,1,50.325,56.1a22.935,22.935,0,0,1-16.851-6.924A22.935,22.935,0,0,1,26.55,32.325a22.935,22.935,0,0,1,6.924-16.851A22.935,22.935,0,0,1,50.325,8.55Z",
    transform: "translate(693.55 578.551)",
    fill: "#c71414"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(733.588 600.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M0,0,3.5.2,4.856,23.565l-3.5-.2Z",
    transform: "translate(16.901 0) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M1.17.175,4.7,0,3.529,23.278,0,23.454Z",
    transform: "translate(0 3.947) rotate(-48)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error-red.56d30ecd358c76a584f138703da1441f.svg";
export { ForwardRef as ReactComponent };